import { StyleSheet } from 'react-native';
import { Platform, Dimensions } from 'react-native';
let deviceWidth = Dimensions.get('window').width;

export default StyleSheet.create({
  headerView: {
    width: '100%',
    height: 76,
    padding: 30,
    justifyContent: 'center',
  },
  popupHeaderView: {
    width: '100%',
    height: 76,
    padding: 30,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
  },

  headertext: {
    height: 34,
    fontWeight: '600',
    textAlign: 'left',
    color: 'white',
    fontSize: Platform.OS == 'web' ? 26 : 20,
    fontFamily: 'SFProText',
  },
  headertextCenter: {
    width: '60%',
    justifyContent: 'center',
    alignItems: 'flex-end',
    fontWeight: 'bold',
    textAlign: 'right',
    color: 'white',
    fontSize: 20,
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  headerTextCenter_SMALL_MOBILE: {
    width: '70%',
    fontSize: 15,
  },
  headerTextCenter_MEDIUM_MOBILE: {
    fontSize: 16,
    width: '70%',
  },
  headerTextCenter_LARGE_MOBILE: {
    fontSize: 18,
    width: '70%',
  },

  headerTextCenter_SMALL_TABLET: {
    width: '65%',
  },
  headerTextCenter_MEDIUM_TABLET: {
    width: '65%',
  },
  headerTextCenter_LARGE_TABLET: {
    width: '65%',
  },
  headerTextCenter_LAPTOP: {
    width: '60%',
  },

  close: { width: 18, height: 18, resizeMode: 'contain' },
  closeView: {
    width: '40%',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  closeView_SMALL_MOBILE: {
    width: '30%',
  },
  closeView_MEDIUM_MOBILE: {
    width: '30%',
  },
  closeView_LARGE_MOBILE: {
    width: '30%',
  },
  closeView_SMALL_TABLET: {
    width: '25%',
  },
  closeView_MEDIUM_TABLET: {
    width: '35%',
  },
  closeView_LARGE_TABLET: {
    width: '35%',
  },
  closeView_LAPTOP: {
    width: '40%',
  },
});
